import { UserModel } from './user.model';

export class EpcProjectModel {
  agencyCode: string;
  agencyName: string;
  createdBy: UserModel;
  biblios: any[];
  createdDatetime?: Date;
  grantNumber: string;
  id: number;
  isLocked: boolean;
  isValid: boolean;
  name: string;
  recordLastUpdateDatetime: Date;
  updatedBy?: UserModel;
  updatedDatetime?: Date;
}
